(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-trust"] && !Shopify.designMode) return;
  try {
    
class ResenasTrustpilot {
  constructor(raiz) {
    this.raiz = raiz;
    this.pista = raiz.querySelector('[data-resenas-trustpilot-pista]');
    this.slides = Array.from(raiz.querySelectorAll('[data-resenas-trustpilot-slide]'));
    this.contenedorPuntos = raiz.querySelector('[data-resenas-trustpilot-puntos]');
    this.botonAnterior = raiz.querySelector('[data-resenas-trustpilot-anterior]');
    this.botonSiguiente = raiz.querySelector('[data-resenas-trustpilot-siguiente]');
    this.autoplay = raiz.dataset.autoplay === 'true';
    this.velocidad = (parseFloat(raiz.dataset.velocidad) || 5) * 1000;
    this.visiblesMovil = parseInt(raiz.dataset.visiblesMovil, 10) || 1;
    this.visiblesTablet = parseInt(raiz.dataset.visiblesTablet, 10) || 1;
    this.visiblesEscritorio = parseInt(raiz.dataset.visiblesEscritorio, 10) || 3;
    this.indice = 0;
    this.temporizador = null;
    if (!this.slides.length) return;
    this.construirPuntos();
    this.botonAnterior && this.botonAnterior.addEventListener('click', () => this.mover(-1));
    this.botonSiguiente && this.botonSiguiente.addEventListener('click', () => this.mover(1));
    window.addEventListener('resize', () => this.actualizar());
    this.actualizar();
    this.iniciarAutoplay();
  }

  obtenerVisibles() {
    const ancho = window.innerWidth;
    if (ancho >= 990) return this.visiblesEscritorio;
    if (ancho >= 750) return this.visiblesTablet;
    return this.visiblesMovil;
  }

  obtenerTotalPaginas() {
    const visibles = this.obtenerVisibles();
    return Math.max(1, this.slides.length - visibles + 1);
  }

  construirPuntos() {
    if (!this.contenedorPuntos) return;
    this.contenedorPuntos.innerHTML = '';
    this.puntos = [];
    const totalPaginas = this.obtenerTotalPaginas();
    for (let i = 0; i < totalPaginas; i += 1) {
      const punto = document.createElement('button');
      punto.type = 'button';
      punto.className = 'resenas-trustpilot-punto';
      punto.addEventListener('click', () => {
        this.indice = i;
        this.actualizar(true);
        this.reiniciarAutoplay();
      });
      this.contenedorPuntos.appendChild(punto);
      this.puntos.push(punto);
    }
  }

  actualizar(reconstruirPuntos) {
    const totalPaginas = this.obtenerTotalPaginas();
    if (this.indice >= totalPaginas) this.indice = totalPaginas - 1;
    if (this.indice < 0) this.indice = 0;
    if (reconstruirPuntos !== true) this.construirPuntos();
    const visibles = this.obtenerVisibles();
    const desplazamiento = (100 / visibles) * this.indice;
    this.pista.style.transform = 'translateX(-' + desplazamiento + '%)';
    if (this.puntos) {
      this.puntos.forEach((punto, i) => {
        punto.classList.toggle('resenas-trustpilot-punto--activo', i === this.indice);
      });
    }
  }

  mover(direccion) {
    const totalPaginas = this.obtenerTotalPaginas();
    this.indice = (this.indice + direccion + totalPaginas) % totalPaginas;
    this.actualizar(true);
    this.reiniciarAutoplay();
  }

  iniciarAutoplay() {
    if (!this.autoplay) return;
    this.temporizador = setInterval(() => this.mover(1), this.velocidad);
  }

  reiniciarAutoplay() {
    if (!this.autoplay) return;
    if (this.temporizador) clearInterval(this.temporizador);
    this.iniciarAutoplay();
  }
}

document.querySelectorAll('[data-resenas-trustpilot-id]').forEach((raiz) => {
  new ResenasTrustpilot(raiz);
});

  } catch(e) { console.error(e); }
})();
})();
